import variables from "@app/assets/_variables.module.scss";
import { ConfigProvider, theme, ThemeConfig } from "antd";
import _merge from "lodash/merge";

export default function ThemeProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    return <ConfigProvider theme={currentTheme}>{children}</ConfigProvider>;
}

const commonThemeConfig: ThemeConfig = {
    token: {
        colorPrimary: variables.colorPrimary,
        fontFamily: "roboto, sans-serif",
    },
};

const darkThemeConfig: ThemeConfig = {
    token: {
        colorBgBase: variables.darkThemeColorBgBase,
        colorTextBase: variables.darkThemeColorTextBase,
        colorBorder: variables.darkThemeColorBorder,
        colorBorderSecondary: variables.darkThemeColorBorderSecondary,
    },
    components: {
        Pagination: {
            colorBgTextActive: variables.darkThemePaginationColorBgTextActive,
            colorPrimaryBorder: variables.darkThemePaginationColorPrimaryBorder,
            colorPrimary: variables.darkThemePaginationColorPrimary,
            colorPrimaryHover: variables.darkThemePaginationColorPrimaryHover,
        },
        Tabs: {
            titleFontSize: 20,
            inkBarColor: variables.darkThemeTabsActiveColor,
            itemActiveColor: variables.darkThemeTabsActiveColor,
            itemSelectedColor: variables.darkThemeTabsActiveColor,
            itemColor: variables.darkThemeTabsDefaultColor,
            itemHoverColor: variables.darkThemeTabsHoverColor,
        },
    },
    algorithm: theme.darkAlgorithm,
};

const lightThemeConfig: ThemeConfig = {
    token: {
        colorTextBase: variables.lightThemeColorTextBase,
        colorBgBase: variables.lightThemeColorBgBase,
        colorBgLayout: variables.lightThemeColorBgLayout,
        boxShadow: "0px 1px 28px 0px #DCDFF2",
    },
    components: {
        Layout: {
            colorBgBody: variables.lightThemeColorBgBody,
        },
        Tabs: {
            titleFontSize: 20,
            itemColor: variables.lightThemeTabsDefaultColor,
            inkBarColor: variables.lightThemeTabsActiveColor,
            itemActiveColor: variables.lightThemeTabsActiveColor,
            itemSelectedColor: variables.lightThemeTabsActiveColor,
            itemHoverColor: variables.lightThemeTabsHoverColor,
        },
        Input: {
            activeBorderColor: "#6AE942",
            hoverBorderColor: "#6AE942",
            activeShadow: "#6AE942",
        },
        Switch: {
            colorPrimary: "#6AE942",
            colorPrimaryHover: "#6AE942",
        },
    },
};

const themeMap = {
    dark: darkThemeConfig,
    light: lightThemeConfig,
};

const currentTheme = _merge(themeMap.light, commonThemeConfig);
